<template>
  <div class="create-acivity">
    <div v-if="divIndex === 1" class="create-acivity" style="margin:0;padding:0;">
      <div class="acivity-left">
      <div class="add-activity-content">
        <div class="control-type-title">
          <p>添加内容</p>
        </div>
        <div v-for="item in selectType" class="control-type" @click="dialogClick(item.index)" :key="item.index">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="acivity-right">
      <div class="mobile-content">
        <div class="scrol-control">
          <div class="control-part-title">
          <el-input class="title-input" v-model="formInline.activity_name" placeholder="点此更改活动标题" clearable></el-input>
        </div>
        <div class="control-part-bottom">
          <el-form>
            <el-form-item>
              <el-upload
                v-loading="loading"
                class="acivity-uploader"
                style="width:100%"
                name="file_upload"
                :action="uploadURL"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                  <div v-if="formInline.cover_img" class="upload_img">
                    <img v-if="formInline.cover_img" :src="formInline.cover_img" class="acivity">
                    <div class="modify_img"><p>点击修改</p></div>
                  </div>
                  <!-- <i v-else class="el-icon-plus acivity-uploader-icon"></i> -->
                  <img v-else src="../../assets/images/Group.png" class="default-acivity">
                  <div v-if="!formInline.cover_img" slot="tip" class="el-upload__tip" style="width:100%">请选择1M以下，支持上传jpg/png文件</div>
              </el-upload>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-input placeholder="场次名称" class="qrcode-input" disabled v-model="formInline.qrcode_name"></el-input>
            </el-form-item>
          </el-form>
            <draggable v-model="controlArray" :options="{group:'people'}" @start="drag=true" @end="drag=false">
              <div class="drag-content" v-for="item in controlArray" :key="item.index" @mouseover="showModel(item)" @mouseout="hideModel(item)">
                  <div class="must-write" v-if="(item.is_require === 1 && item.type === 'input') || (item.is_require === 1 &&item.type === 'cascader') || (item.is_require === 1 && item.type === 'select') || (item.is_require === 1 && item.type === 'datePicker') || (item.is_require === 1 && item.type === 'dateTimePicker')">*</div>
                  <el-input
                    v-if="item.type === 'input'"
                    class="acivity-input"
                    :type="item.textType"
                    disabled
                    :placeholder="item.name">
                  </el-input>
                  <el-cascader
                    v-if="item.type === 'cascader'"
                    class="acivity-input"
                    :type="item.textType"
                    :options="addressOptions"
                    disabled
                    :placeholder="item.name">
                  </el-cascader>
                  <el-select
                    disabled
                    class="acivity-input"
                    v-if="item.type === 'select'"
                    v-model="item.value"
                    :placeholder="item.name" >
                    <el-option
                      v-for="items in item.options"
                      :key="items.value"
                      :label="items.label"
                      :value="items.value">
                    </el-option>
                  </el-select>
                  <el-date-picker
                    disabled
                    class="acivity-input"
                    v-if="item.type === 'datePicker' || item.type === 'dateTimePicker'"
                    :type="item.textType"
                    :placeholder="item.name">
                  </el-date-picker>
                  <div class="checkbox-content">
                    <div v-if="item.type === 'checkBox'" class="checkbox-span">
                      <div class="check-write" v-if="item.is_require === 1">*</div>
                      <div class="check-write-white" v-if="item.is_require === 2 || item.is_require === 0">*</div>
                      {{ item.name }}
                    </div>
                    <el-checkbox-group
                      class="checkbox"
                      disabled
                      v-if="item.type === 'checkBox'">
                      <el-checkbox v-for="checkout in item.options" :label="checkout" :key="checkout">
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="radio-content">
                    <div v-if="item.type === 'radio'" class="checkbox-span">
                      <div class="check-write" v-if="item.is_require === 1">*</div>
                      <div class="check-write-white" v-if="item.is_require === 2 || item.is_require === 0">*</div>
                      {{ item.name }}
                    </div>
                    <el-radio-group
                      class="radio-group"
                      v-if="item.type === 'radio'"
                      disabled
                      :type="item.textType"
                      v-model="radio2">
                      <el-radio :label="item" v-for="item in item.options" :key="item">{{item}}</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="item-model" v-if="item.itemShowModel === true">
                    <div @click="deleteAttrItemPhone(item)" class="item-model-content">
                      <i class="iconfont icon-shanchu"></i>
                      <span>删除</span>
                    </div>
                  </div>
              </div>
            </draggable>
            <div class="apply-button">申请</div>
          </div>
        </div>
      </div>
        <!-- 配置 -->
        <el-form class="control-part-form">
          <el-form-item style="margin-top: 30px;" class="form-submit-page">
            <el-button class="second-page-btn" style="float: left;" type="primary" @click="nextStepAction">下一步</el-button>
          </el-form-item>
        </el-form>
          <!-- 文本 -->
          <el-dialog class="cellDialog" title="文本设置" :visible.sync="textDialog" width="350px">
            <el-form label-width="70px">
              <el-form-item class="text-content" label="字段名称">
                <el-input v-model="textTitle" placeholder="" clearable></el-input>
              </el-form-item>
              <el-form-item class="text-content" label="文本类型">
                <el-radio v-model="textRadio" :label="1">单行文本</el-radio>
                <el-radio v-model="textRadio" :label="0">多行文本</el-radio>
              </el-form-item>
              <el-form-item class="text-content" label="是否必填">
                <el-radio v-model="is_require" :label="1">是</el-radio>
                <el-radio v-model="is_require" :label="0">否</el-radio>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="reply-btn-type-goback" @click="textDialog = false">取 消</el-button>
              <el-button class="dialog-confirm-btn" type="primary" @click="textAction">确 定</el-button>
            </div>
          </el-dialog>
          <el-dialog class="cellDialog" title="下拉菜单设置" :visible.sync="selectDialog" width="350px">
            <el-form label-width="70px" class="text-content">
              <el-form-item class="text-content" label="字段名称">
                <el-input v-model="textTitle" placeholder="" clearable style="width: 197px;"></el-input>
              </el-form-item>
              <el-form-item :label="item.label" v-for="item in selectOptionsArray" :key="item.name">
                <el-input v-model="item.subtitle" placeholder="" clearable style="width: 197px;"></el-input><span class="close-span" @click="closeSelect(item)">删除</span>
              </el-form-item>
              <div class="add_option" @click="addSelectOptions">增加可选项</div>
              <el-form-item class="text-content" label="是否必填">
                <el-radio v-model="is_require" :label="1">是</el-radio>
                <el-radio v-model="is_require" :label="0">否</el-radio>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="reply-btn-type-goback" @click="selectDialog = false">取 消</el-button>
              <el-button class="dialog-confirm-btn" type="primary" @click="confirmSelectAction">确 定</el-button>
            </div>
          </el-dialog>
          <el-dialog class="cellDialog" title="时间设置" :visible.sync="timeDialog" width="350px">
            <el-form label-width="70px" class="text-content">
              <el-form-item class="text-content" label="字段名称" label-width="">
                <el-input v-model="textTitle" placeholder="" clearable></el-input>
              </el-form-item>
              <el-form-item class="text-content" label="时间类型">
                <el-radio v-model="dateRadio" :label="0">日期</el-radio>
                <el-radio v-model="dateRadio" :label="1">日期和时间</el-radio>
              </el-form-item>
              <el-form-item class="text-content" label="是否必填">
                <el-radio v-model="is_require" :label="1">是</el-radio>
                <el-radio v-model="is_require" :label="0">否</el-radio>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="reply-btn-type-goback" @click="timeDialog = false">取 消</el-button>
              <el-button class="dialog-confirm-btn" type="primary" @click="confirmTimeAction()">确 定</el-button>
            </div>
          </el-dialog>
          <!--复选-->
          <el-dialog class="cellDialog" title="复选设置" :visible.sync="checkboxDialog" width="350px">
            <el-form label-width="70px" class="text-content">
              <el-form-item class="text-content" label="字段名称" label-width="">
                <el-input v-model="textTitle" placeholder="请输入字段名称" clearable style="width: 197px;"></el-input>
              </el-form-item>
              <el-form-item :label="item.label" v-for="item in checkoutBoxArray" :key="item.name">
                <el-input v-model="item.subtitle" :maxlength="15" placeholder="请输入选项" clearable style="width: 197px;" @blur="judegCheckBoxValue(item.subtitle)">
                </el-input>
                <span class="close-span" @click="closeCheckoutBox(item)">删除</span>
              </el-form-item>
              <div class="add_option" @click="addCheckBoxOptions">增加可选项</div>
              <el-form-item class="text-content" label="是否必填">
                <el-radio v-model="is_require" :label="1">是</el-radio>
                <el-radio v-model="is_require" :label="0">否</el-radio>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="reply-btn-type-goback" @click="checkboxDialog = false">取 消</el-button>
              <el-button class="dialog-confirm-btn" type="primary" @click="confirmCheckoutBox">确 定</el-button>
            </div>
          </el-dialog>
          <!--单选-->
          <el-dialog class="cellDialog" title="单选设置" :visible.sync="oneSelectDialog" width="350px">
            <el-form label-width="70px" class="text-content">
              <el-form-item class="text-content" label="字段名称" label-width="">
                <el-input v-model="textTitle" placeholder="请输入字段名称" clearable style="width: 197px;"></el-input>
              </el-form-item>
              <el-form-item :label="item.label" v-for="item in radioArray" :key="item.name">
                <el-input v-model="item.subtitle" placeholder="请输入选项" :maxlength="15" clearable style="width: 197px;" @blur="judegValue(item.subtitle)">
                </el-input><span class="close-span" @click="closeOneSelect(item)">删除</span>
              </el-form-item>
              <div class="add_option" @click="addRadioOptions">增加可选项</div>
              <el-form-item class="text-content" label="是否必填">
                <el-radio v-model="is_require" :label="1">是</el-radio>
                <el-radio v-model="is_require" :label="0">否</el-radio>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="reply-btn-type-goback" @click="oneSelectDialog = false">取 消</el-button>
              <el-button class="dialog-confirm-btn" type="primary" @click="confirmRadioAction()">确 定</el-button>
            </div>
          </el-dialog>
        </div>
    </div>
    <div v-if="divIndex === 2" style="width:100%">
      <el-row class="box-content" style="width:100%">
        <div class="box-content-div form-submit-page">
          <el-form label-width="90px" style="text-align: left;width: 520px;margin:20px auto;" :model="formInline" ref="formInline" :rules="rules" class="box-content-form">
            <!-- <el-form-item label="公众号:" prop="public_id">
              <el-select @change="changePublic" v-model="formInline.public_id" placeholder="请选择">
                <el-option
                  v-for="item in publicOptions"
                  :key="item.id"
                  :label="item.nick_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="标签:" class="picture-text-item">
              <tags-template v-model="formInline.tags"></tags-template>
            </el-form-item>
            <el-form-item label="二维码logo:">
              <el-upload
                name="file_upload"
                :action="uploadURL"
                title="可以点击图片进行换图"
                :show-file-list="false"
                :on-success="handleSuccessLogo"
                :before-upload="beforeAvatarUpload">
                <div v-if="formInline.logo_url" class="upload_img">
                  <img v-if="formInline.logo_url" :src="formInline.logo_url" class="acivity_logo">
                  <div class="modify_img" style="width:200px;height200px;line-height:200px;">点击修改</div>
                </div>
                <img v-else src="../../assets/images/Group.png" class="default-acivity" style="margin:0">
                <div slot="tip" class="el-upload__tip" style="line-height: 20px;">请选择1M以下，支持上传jpg/png文件</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="客户来源:" prop="source_id">
              <el-select v-model="formInline.source_id" placeholder="请选择客户来源">
                <el-option
                  v-for="item in sources"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="来源说明:" prop="source_data">
              <el-input type="textarea" style="width: 190px;" v-model="formInline.source_data"></el-input>
            </el-form-item>
            <el-form-item label="回复内容:" style="text-align: center;">
              <div class="radioGroup add_offline" style="width: 100%">
                <el-radio-group v-model="formInline.replay_type" style="width: 404px;" @change="handleClick" :disabled="formInline.is_isset_scan_num === 1 ? true : false">
                  <el-radio :label="0">不回复</el-radio>
                  <el-radio :label="1">文本</el-radio>
                  <el-radio :label="2">图片</el-radio>
                  <el-radio :label="3">微页面</el-radio>
                  <el-radio :label="4">外部页</el-radio>
                  <el-radio :label="5">大转盘</el-radio>
                </el-radio-group>
              </div>
              <el-collapse-transition>
                <div v-if="formInline.replay_type == 1">
                  <el-input type="textarea" :maxlength="500" v-model="formInline.replay_text"></el-input>
                  <p>还可输入{{ 500 - formInline.replay_text.length }}字</p>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div v-if="formInline.replay_type == 2">
                  <el-upload
                    v-loading="loading"
                    class="acivity-uploader add_offline_activity"
                    name="file_upload"
                    :action="uploadURL"
                    :show-file-list="false"
                    :on-success="handleReplayimgSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="formInline.replay_img" :src="formInline.replay_img" class="acivity">
                    <!-- <i v-else class="el-icon-plus acivity-uploader-icon"></i> -->
                    <img v-else src="../../assets/images/Group.png" class="default-acivity">
                    <div slot="tip" class="el-upload__tip" style="width:100%; text-align:center">请选择1M以下，支持上传jpg/png文件</div>
                  </el-upload>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div v-if="formInline.replay_type == 3">
                  <div class="external_page" style="padding: 20px 36px;box-sizing: border-box;">
                    <el-form-item label="微页面名称:" style="text-align: left;" label-width="90px">
                      <el-select v-model="formInline.replay_scene_id" filterable placeholder="请选择微页面名称" :disabled="formInline.is_isset_scan_num === 1 ? true : false">
                        <el-option
                          v-for="item in wePagesOptions"
                          :key="item.id"
                          :label="item.admin_title"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div v-if="formInline.replay_type == 4">
                  <div class="external_page">
                    <el-form-item label="链接" class="out-page" label-width="90px">
                       <el-input
                        type="text"
                        style="width: 190px;"
                        v-model="formInline.reply_page_url"
                        :disabled="formInline.is_isset_scan_num === 1 ? true : false">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="标题" class="out-page" label-width="90px">
                       <el-input
                         type="text"
                         style="width: 190px;"
                         v-model="formInline.reply_page_title"
                         :disabled="formInline.is_isset_scan_num === 1 ? true : false">
                       </el-input>
                    </el-form-item>
                    <el-form-item label="摘要" class="out-page" label-width="90px">
                      <el-input
                        :disabled="formInline.is_isset_scan_num === 1 ? true : false"
                        type="text"
                        style="width: 190px;"
                        v-model="formInline.reply_page_description">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="封面" class="out-page" label-width="90px">
                      <el-upload
                        :disabled="formInline.is_isset_scan_num === 1 ? true : false"
                        v-loading="loading"
                        class="acivity-uploader"
                        name="file_upload"
                        :action="uploadURL"
                        :show-file-list="false"
                        :on-success="handleOutrPageSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="formInline.reply_page_pic" :src="formInline.reply_page_pic" class="acivity" style="max-width:237px;">
                        <!-- <i v-else class="el-icon-plus acivity-uploader-icon"></i> -->
                        <img v-else src="../../assets/images/Group.png" class="default-acivity" style="margin: 0 0 0 55px;">
                        <div slot="tip" class="el-upload__tip">请选择1M以下，支持上传jpg/png文件</div>
                      </el-upload>
                    </el-form-item>
                  </div>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div v-if="formInline.replay_type == 5">
                  <div class="external_page" style="padding: 20px 36px;box-sizing: border-box;">
                    <el-form-item label="大转盘名称" class="out-page" label-width="90px">
                      <el-select
                        v-model="formInline.replay_lottery_id"
                        filterable
                        placeholder="请选择大转盘名称"
                        :disabled="formInline.is_isset_scan_num === 1 ? true : false">
                        <el-option
                          v-for="item in bigWheelOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </el-collapse-transition>
            </el-form-item>
            <el-form-item label="" >
              <el-button class="reply-btn-type-goback" style="margin-right: 10px;float: left"  @click="divIndex = 1">上一步</el-button>
              <el-button class="second-page-btn" style="float: left;" type="primary"  @click="submitForm('formInline')">完成</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { addAcivity, getWechatPublicListForNode, getCustomerSourceListForWepage, addWeChayAcivity, getWeChatActivityDetails, editWeChatActivity, getWePagesList, getActivityList } from '@/api/customer.js'
import { regionData, CodeToText } from 'element-china-area-data'
import tagsTemplate from '@/components/common/tags-template'
import draggable from 'vuedraggable'
export default {
  name: 'editOffineActivity',
  data() {
    return {
      bigWheelOptions: [],
      loading: false,
      rules: {
        public_id: [
          { required: true, message: '请选择公众号', trigger: 'blur' }
        ],
        source_id: [
          { required: true, message: '请选择客户来源', trigger: 'blur' }
        ],
        source_data: [
          { required: true, message: '请输入来源说明', trigger: 'blur' }
        ]
      },
      dateType: 'date',
      is_require: 0,
      textRadio: 1,
      textType: '',
      customerSource: '',
      sources: [],
      publicid: '',
      divIndex: 1,
      radio2: '',
      checkedCities: [],
      addressOptions: regionData,
      radioOptionArry: [],
      radioArray: [
        {
          label: '选项1',
          index: 0,
          subtitle: ''
        }
      ],
      checkoutBoxArray: [
        {
          label: '选项1',
          index: 0,
          subtitle: ''
        }
      ],
      value1: '',
      oneSelectDialog: false,
      selectDialog: false,
      checkboxDialog: false,
      selectOptions: [],
      selectOptionsArray: [
        {
          label: '选项1',
          index: 0,
          subtitle: ''
        }
      ],
      checkoutArray: [
        {
          label: '选项1',
          index: 0,
          subtitle: ''
        }
      ],
      textTitle: '',
      radio: '',
      textDialog: false,
      timeDialog: false,
      controlArray: [],
      options: regionData,
      checkoutBox: [],
      form: {
        public_id: '',
        publish_status: 1,
        status: 1
      },
      formInline: {
        activity_name: '',
        logo_url: '', // 二维码logo
        cover_img: '',
        qrcode_name: '',
        public_id: '',
        source_id: '',
        source_data: '',
        replay_type: 0,
        replay_text: '',
        replay_scene_id: '',
        replay_lottery_id: '',
        reply_page_url: '',
        reply_page_title: '',
        reply_page_description: '',
        reply_page_pic: ''
      },
      selectType: [
        {
          title: '省市区',
          index: 0
        },
        {
          title: '文本',
          index: 1
        },
        {
          title: '时间',
          index: 2
        },
        {
          title: '复选',
          index: 3
        },
        {
          title: '单选',
          index: 4
        }
      ],
      publicOptions: [],
      dateRadio: 0,
      wePagesOptions: []
    }
  },
  components: {
    tagsTemplate,
    draggable
  },
  methods: {
    // 判断单选值是否有相同的
    judegValue(val) {
      this.count = 0
      for (let i in this.radioArray) {
        if (val === this.radioArray[i].subtitle) {
          this.count++
        }
      }
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
      }
    },
    // 判断复选值是否有相同的
    judegCheckBoxValue(val) {
      this.count = 0
      for (let i in this.checkoutBoxArray) {
        if (val === this.checkoutBoxArray[i].subtitle) {
          this.count++
        }
      }
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
      }
    },
    // 切换公众号
    changePublic() {
      this.loadMicroPageList()
      this.getBigWheelOptions()
    },
    deleteAttrItemPhone(item) {
      this.$confirm('确认删除该属性?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let index = this.controlArray.indexOf(item)
        this.controlArray.splice(index, 1)
      }).catch((error) => {
        console.log(error)
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formInline.replay_type === 1 && this.formInline.replay_text === '') {
            _g.toastMsg('error', '请填入回复信息')
            return
          }
          if (this.formInline.replay_type === 2 && this.formInline.replay_img === '') {
            _g.toastMsg('error', '请填入回复图片')
            return
          }
          if (this.formInline.replay_type === 3 && this.formInline.replay_scene_id === '') {
            _g.toastMsg('error', '请选择微页面')
            return
          }
          if (this.formInline.replay_type === 4 && this.formInline.reply_page_url === '') {
            _g.toastMsg('error', '请填入回复信息')
            return
          }
          if (this.formInline.replay_type === 5 && this.formInline.replay_lottery_id === '') {
            _g.toastMsg('error', '请选择大转盘')
            return
          }
          this.addAcivity()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    nextStepAction() {
      if (this.formInline.activity_name === '') {
        _g.toastMsg('error', '请填写活动标题')
        return
      }
      if (this.formInline.cover_img === '') {
        _g.toastMsg('error', '请填写活动封面')
        return
      }
      if (this.controlArray.length === 0) {
        _g.toastMsg('error', '活动内容不能为空')
        return
      }
      this.divIndex = 2
    },
    // 隐藏手机模态层
    hideModel(item) {
      item.itemShowModel = false
    },
    // 显示出手机模态层
    showModel(item) {
      item.itemShowModel = true
    },
    addAcivity() {
      this.formInline.activity_data = this.controlArray
      let id = this.$route.query.id
      editWeChatActivity(this.formInline, id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/offline-activity-list')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    getCustomerSource() {
      getCustomerSourceListForWepage().then(res => {
        this.sources = res.data.data.list
        let flag = 0
        this.sources.some(item => {
          if (item.id !== this.formInline.source_id) {
            flag++
          }
          if (flag === this.sources.length) {
            this.formInline.source_id = ''
          }
        })
      })
      console.log('ssssssss', this.sources)
    },
    confirmRadioAction() {
      if (this.textTitle === '') {
        _g.toastMsg('error', '请填入字段名称')
        return
      }
      if (this.radioArray.length <= 1 && this.radioArray[0].subtitle === '') {
        _g.toastMsg('error', '请填入选项')
        return
      }
      if (this.count > 1) {
        _g.toastMsg('error', '单选选项值不能相同')
        return
      }
      for (let item of this.radioArray) {
        this.radioOptionArry.push(item.subtitle)
      }
      this.oneSelectDialog = false
      this.controlArray.push({
        type: 'radio',
        value: '',
        options: this.radioOptionArry,
        itemShowModel: false,
        is_require: this.is_require,
        name: this.textTitle
      })
      this.radioOptionArry = []
      this.resetNum()
    },
    addRadioOptions() {
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
        return
      }
      this.radioArray.push({
        label: '选项' + (this.radioArray.length + 1),
        index: this.radioArray.length + 1,
        subtitle: ''
      })
    },
    confirmCheckoutBox() {
      if (this.textTitle === '') {
        _g.toastMsg('error', '请填入字段名称')
        return
      }
      if (this.checkoutBoxArray.length <= 1 && this.checkoutBoxArray[0].subtitle === '') {
        _g.toastMsg('error', '请填入选项')
        return
      }
      for (let item of this.checkoutBoxArray) {
        if (this.count > 1) {
          _g.toastMsg('error', '复选选项值不能相同')
          return
        }
        this.checkoutBox.push(item.subtitle)
      }
      this.checkboxDialog = false
      this.controlArray.push({
        value: [],
        type: 'checkBox',
        options: this.checkoutBox,
        itemShowModel: false,
        is_require: this.is_require,
        name: this.textTitle
      })
      this.checkoutBox = []
      this.resetNum()
    },
    resetNum() {
      this.textTitle = ''
      this.is_require = 0
    },
    // 删除复选框选项
    closeCheckoutBox(item) {
      let index = this.checkoutBoxArray.indexOf(item)
      this.checkoutBoxArray.splice(index, 1)
    },
    // 删除下拉菜单选项
    closeSelect(item) {
      let index = this.selectOptionsArray.indexOf(item)
      this.selectOptionsArray.splice(index, 1)
    },
    // 删除单选选项
    closeOneSelect(item) {
      let index = this.radioArray.indexOf(item)
      this.radioArray.splice(index, 1)
    },
    addCheckBoxOptions() {
      if (this.count > 1) {
        _g.toastMsg('error', '选项值不能相同')
        return
      }
      this.checkoutBoxArray.push({
        label: '选项' + (this.checkoutBoxArray.length + 1),
        index: this.checkoutBoxArray.length + 1,
        subtitle: ''
      })
    },
    // 添加时间插件
    confirmTimeAction() {
      if (this.textTitle === '') {
        _g.toastMsg('error', '请填入字段名称')
        return
      }
      if (this.dateRadio === 1) {
        this.dateType = 'dateTimePicker'
      } else {
        this.dateType = 'datePicker'
      }
      this.timeDialog = false
      this.controlArray.push({
        type: this.dateType,
        value: '',
        itemShowModel: false,
        is_require: this.is_require,
        name: this.textTitle
      })
      this.resetNum()
    },
    confirmSelectAction() {
      if (this.textTitle === '') {
        _g.toastMsg('error', '请填入字段名称')
        return
      }
      if (this.selectOptionsArray.length <= 1 && this.selectOptionsArray[0].subtitle === '') {
        _g.toastMsg('error', '请填入选项')
        return
      }
      for (let item of this.selectOptionsArray) {
        this.selectOptions.push(item.subtitle)
      }
      this.selectDialog = false
      this.controlArray.push({
        type: 'select',
        value: '',
        itemShowModel: false,
        is_require: this.is_require,
        options: this.selectOptions,
        name: this.textTitle
      })
      this.selectOptions = []
      this.resetNum()
    },
    addSelectOptions() {
      this.selectOptionsArray.push({
        label: '选项' + (this.selectOptionsArray.length + 1),
        index: this.selectOptionsArray.length + 1,
        subtitle: ''
      })
    },
    textAction() {
      if (this.textTitle === '') {
        _g.toastMsg('error', '请填入字段名称')
        return
      }
      if (this.textRadio === 1) {
        this.controlArray.push({
          type: 'input',
          value: '',
          textType: 'text',
          itemShowModel: false,
          is_require: this.is_require,
          name: this.textTitle
        })
      } else {
        this.controlArray.push({
          type: 'input',
          value: '',
          textType: 'textarea',
          itemShowModel: false,
          is_require: this.is_require,
          name: this.textTitle
        })
      }
      this.textDialog = false
    },
    dialogClick(index) {
      this.resetNum()
      if (index === 0) {
        this.controlArray.push({
          type: 'cascader',
          value: [],
          itemShowModel: false,
          index: this.controlArray.length,
          name: '省市区'
        })
      } else if (index === 1) {
        this.textDialog = true
      } else if (index === 2) {
        this.timeDialog = true
      } else if (index === 3) {
        this.checkboxDialog = true
        this.checkoutBoxArray = [
          {
            label: '选项1',
            index: 0,
            subtitle: ''
          }
        ]
      } else if (index === 4) {
        this.oneSelectDialog = true
        this.radioArray = [
          {
            label: '选项1',
            index: 0,
            subtitle: ''
          }
        ]
      }
    },
    handleReplayimgSuccess(res, file) {
      this.loading = false
      _g.toastMsg('success', '上传成功')
      this.formInline.replay_img = res.data.path
    },
    handleOutrPageSuccess(res, file) {
      this.loading = false
      _g.toastMsg('success', '上传成功')
      this.formInline.reply_page_pic = res.data.path
    },
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.cover_img = res.data.path
      this.loading = false
    },
    handleSuccessLogo(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.logo_url = res.data.path
      this.loading = false
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      this.loading = true
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt1M = file.size / 1024 / 1024 <= 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
        this.loading = false
      }
      if (!isLt1M) {
        _g.toastMsg('error', '上传头像图片大小不能超过 1MB!')
        this.loading = false
      }
      return (isJPG && isLt1M) || (isPNG && isLt1M)
    },
    getPublicList() {
      getWechatPublicListForNode().then((res) => {
        this.publicOptions = res.data.data.list
      })
    },
    handleClick() {
      // this.formInline.replay_type = tab.index
      this.formInline.replay_text = ''
      this.formInline.replay_img = ''
      this.formInline.replay_scene_id = ''
      this.formInline.reply_page_url = ''
      this.formInline.reply_page_title = ''
      this.formInline.reply_page_description = ''
      this.formInline.reply_page_pic = ''
      this.formInline.replay_lottery_id = ''
    },
    loadMicroPageList() {
      this.form.public_id = this.$route.query.public_id
      this.form.publish_status = 1
      getWePagesList(1, '', this.form).then((res) => {
        if (res.data.code === 0) {
          this.wePagesOptions = res.data.data.list
          let flag = 0
          this.wePagesOptions.some(item => {
            if (item.id !== this.formInline.replay_scene_id) {
              flag++
            }
            if (flag === this.wePagesOptions.length) {
              this.formInline.replay_scene_id = ''
            }
          })
        }
      })
    },
    getData() {
      let id = this.$route.query.id
      getWeChatActivityDetails(id).then(res => {
        this.formInline = JSON.parse(JSON.stringify(res.data.data))
        this.controlArray = res.data.data.activity_data
        this.loadMicroPageList()
        this.getBigWheelOptions()
        this.getCustomerSource()
      })
    },
    getBigWheelOptions() {
      let _this = this
      this.form.public_id = this.$route.query.public_id
      this.form.status = 1
      getActivityList(1, this.form).then(res => {
        this.bigWheelOptions = res.data.data.list
        let flag = 0
        this.bigWheelOptions.some(item => {
          if (item.id !== this.formInline.replay_lottery_id) {
            flag++
          }
          console.log('flag', flag)
          if (flag === this.bigWheelOptions.length) {
            this.formInline.replay_lottery_id = ''
          }
          console.log('this.formInline.replay_lottery_id', this.formInline.replay_lottery_id)
        })
      })
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getData()
    // this.getBigWheelOptions()
    this.getPublicList()
    // this.loadMicroPageList()
  }
}
</script>

<style scoped>
.add_offline_activity{
  background: transparent;
  border: none;
  width: 100%;
  margin: 0 auto;
  padding-top: 10px;
}
.upload_img{
    position: relative;
    width: 200px;
    height: 200px;
}
.upload_img:hover .modify_img{
    display: inline-block;
}
.modify_img{
  position: absolute;
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.6;
  display: none;
  top: 0;
  left: 0;
  color: #fff;
  font-size: 18px;
}
.modify_img>p{
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-45%, -50%);
    }
.add_option{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: #39C6CD;
  text-align: center;
  cursor: pointer;
  padding-right: 10%;
  border-top: 1px solid #e5e5e5;
}
.default-acivity {
  width: 108px;
  display: block;
  margin: 23px auto 0;
}
.external_page{
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  padding-top: 20px;
}
.el-radio+.el-radio{
  margin-left: 0;
}
.box-content-div, .form-submit-page .box-content-form .el-form-item{
  width: auto !important;
}
.create-acivity {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  margin: 20px auto 0;
  padding: 0 20px;
  box-sizing: border-box;
}
.acivity-left {
  width: 330px;
  height: auto;
  display: flex;
  justify-content: center;
  flex-direction: row;
  background: #fff;
  border: 1px solid #EBEBEB;
}
.acivity-right {
  width: calc(100% - 340px);
  margin-left: 20px;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  background: #fff;
}
.add-activity-content {
  width: 320px;
  height: auto;
  /*padding: 10px 10px 10px 10px;*/
  /*background-color: #F5F5F5;*/
}
.control-type {
  border: 1px solid #E7E7E7;
  margin-bottom: 20px;
  border-radius: 6px;
  width: 120px;
  height: 36px;
  line-height: 36px;
  float: left;
  margin: 0 10px 20px;
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;
}
.control-type:hover {
  border: 1px solid #1980FF;
  color: #1980FF;
}
.control-type-title {
  height: 50px;
  margin-bottom: 10px;
  border-bottom: 1px solid #E7E7E7;
}
.control-type-con{
  width: 100%;
  padding: 0 20px;
  margin-top: 25px;
  box-sizing: border-box;
}
.control-type-title p {
  color: #333;
  font-size: 14px;
  line-height: 50px;
  margin: 0;
  width: 100%;
  padding-left: 26px;
  font-weight: 600;
  text-align: left;
}
.mobile-content {
  margin: 50px auto;
  width: 400px;
  height: 828px;
  display: block;
  padding-top: 70px;
  justify-content: flex-start;
  flex-direction: column;
  background: url("../../assets/images/mobile_phone_frame.png") no-repeat center center;
  background-size: 100% 100%;
  /*width: 312px;
  height: 618px;
  margin: 48px auto 0;*/
  box-sizing: border-box;
}
.control-cotent {
  margin-left: 50%;
}
.control-cotent-title {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-bottom: 20px;
  margin-left: 20%;
}
.control-part-one {
  width: 60px;
  height: 60px;
  background-color: #679CFF;
  border-radius: 30px;
  color: #fff;
  line-height: 60px;
  vertical-align: middle;
}
.control-cotent-line {
  height: 1px;
  width: 100px;
  background-color: #dedede;
  margin-top: 29px;
}
.control-part-two {
  width: 60px;
  height: 60px;
  background-color: #999;
  border-radius: 30px;
  color: #fff;
  line-height: 60px;
  vertical-align: middle;
}
.control-part-twos {
  width: 60px;
  height: 60px;
  background-color: #679CFF;
  border-radius: 30px;
  color: #fff;
  line-height: 60px;
  vertical-align: middle;
}
.control-part-title {
  /*background-color: #4D90FF;*/
}
.title-input {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.control-part-bottom {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.external_page .acivity-uploader {
  background: transparent;
  width: auto;
  border: none;
}
.acivity-uploader {
  /*margin-top: 20px;*/
  background: #fff;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  padding-top: 10px;
}
.el-upload {
  display: block;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.acivity-uploader .el-upload:hover {
  border-color: #409EFF;
}
.acivity-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 208px;
  height: 208px;
  line-height: 208px;
  text-align: center;
}
.acivity {
  width: 200px;
  height: 200px;
  display: block;
}
.acivity_logo {
  width: 200px;
  height: 200px;
  display: block;
}
.text-content {
  text-align: left;
}
.text-content .el-form-item {
  text-align: left;
}
.control-part-form {
  width: 112px;
  margin: 0 auto;
}
.add-select-opiontion {
  text-align: right;
}
.close-span {
  display: inline-block;
  margin-left: 10px;
  color: #ff3333;
  cursor: pointer;
}
.out-page {
  text-align: left;
  margin-bottom: 10px;
}
.activity-setting {
  width: 600px;
  margin: auto;
}
.control-cotent-setting {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-top: 30px;
  margin-bottom: 20px;
  margin-left: 10%;
}
.isRequired-span {
  display: inline-block;
  color: #ff3333;
  font-size: 22px;
}
.acivity-input {
  width: 90%;
  margin-bottom: 10px;
}
.qrcode-input {
  width: 90%;
}
.item-model {
  background: #000;
  opacity: 0.6;
  position: absolute;
  left: 5%;
  right: 5%;
  bottom: 0;
  top: 0;
  border-radius: 2px;
  display: flex;
  z-index: 100;
  align-items: center;
  justify-content: space-around;
}
.item-model div{
  width: 80px;
  height: 40px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
}
.item-model div:hover,.item-model div:hover i{
  color: #679CFF;
}
.item-model div i {
  display: block;
  width: 80px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #fff;
}
.must-write {
  width: 5%;
  height: 30px;
  padding-top: 10px;
  position: absolute;
  width: 2px;
  height: 30px;
  display: inline-block;
  left: 0px;
  top: 3px;
  font-size: 20px;
  color: red;
}
.drag-content {
  position: relative;
}
.checkbox-span {
  display: inline-block;
  float: left;
  text-align: left;
  margin-left: 0px;
  width: 205px;
  margin-bottom: 5px;
}
.checkbox-content {
  /*display: flex;
  justify-content: flex-start;
  flex-direction: column;*/
}
.radio-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.scrol-control {
  margin: 0 auto;
  width: 320px;
  height: 688px;
  overflow-y: auto;
  overflow-x: hidden;
}
.check-write {
  color: #ff3333;
  display: inline-block;
  position: relative;
  left: 0;
  top: 7px;
  height: 5px;
  line-height: 5px;
  margin-right: 10px;
  font-size: 20px;
  margin-top: 5px;
}
.check-write-white {
  color: #f5f5f5;
  display: inline-block;
  height: 5px;
  line-height: 5px;
  margin-right: 10px;
  font-size: 20px;
}
.checkbox {
  clear: both;
  text-align: left;
  margin-left: 20px;
  margin-bottom: 10px;
}
.el-checkbox {
  width: 80%;
}
.el-checkbox+.el-checkbox{
  margin-left: 0px;
}
.radio-group {
  display: block;
  margin-left: 15px;
  clear: both;
  text-align: left;
  margin-bottom: 10px;
}
.radio-content .el-radio {
  min-width: 20px;
}
.apply-button {
  width: 100%;
  margin-top: 20px;
  line-height: 45px;
  /*margin-left: 10%;*/
  /*border-radius: 22.5px;*/
  height: 45px;
  background-color: #4D90FF;
  color: #fff;
  font-size: 18px;
}
.item-model-content {
  display: flex;
  justify-content: center;
  flex-direction: row;
  line-height: 20px;
}
.item-model-content span {
  display: inline-block;
  width: 60px;
}
.item-model-content i {
  margin-right: -20px;
}
</style>
